<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.repaircostprice_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/repaircostprice/repaircostprice';
import { mapGetters } from 'vuex';

var V = (rule, value, callback) => {
  if (value > 10000) {
    callback(new Error('请不要输入错误的价格'));
  } else if (value < 0) {
    callback(new Error('请不要输入错误的价格'));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        labelWidth: 130,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '费用类型',
            prop: 'costType',
            rules: [
              {
                required: true,
                message: '请选择费用类型',
                trigger: 'change',
              },
            ],
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=cost_type',
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          {
            label: '费用名称',
            prop: 'costName',
            rules: [
              {
                required: true,
                message: '请输入费用名称',
                trigger: 'change',
              },
            ],
            search: true,
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '计量单位',
            prop: 'unit',
            rules: [
              {
                required: true,
                message: '请选择单位',
                trigger: 'change',
              },
            ],
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=unit',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '价格(元)',
            prop: 'price',
            rules: [
              {
                required: true,
                message: '请输入价格(元)',
                trigger: 'change',
              },
              {
                validator: V,
                message: '请不要输入错误的价格',
                trigger: 'blur',
              },
              {
                pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正整数，正小数（小数位不超过2位）',
              },
            ],
          },
          {
            label: '材质',
            prop: 'materials',
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '型号',
            prop: 'materialType',
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '品牌',
            prop: 'brand',
            maxlength: 15,
            showWordLimit: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repaircostprice_add, false),
        viewBtn: this.vaildData(this.permission.repaircostprice_view, false),
        delBtn: this.vaildData(this.permission.repaircostprice_delete, false),
        editBtn: this.vaildData(this.permission.repaircostprice_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {},
  methods: {
    rowSave(row, loading, done) {
      if (!row.areaId) {
        row.areaId = 0;
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
